import { render } from "./Category.vue?vue&type=template&id=b20b529e"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__